import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IrisFieldEditorComponent } from './field-editor/field-editor.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IrisFieldDepartmentComponent } from './field-department/field-department.component';
import { IrisFieldDepartmentModalComponent } from './field-department/field-department-modal/field-department-modal.component';
import { IrisCommonDirectivesModule } from '../directives-common/common-directives.module';
import { IrisFieldShareSelectComponent } from './field-share-select/field-share-select.component';
import { ColorSketchModule } from 'ngx-color/sketch';
import { ColorSwatchesModule } from 'ngx-color/swatches';
import { IrisCommonPipesModule } from '../pipes-common/common-pipes.module';
import { IrisFieldMultipleStateCheckboxComponent } from './field-multiple-state-checkbox/field-multiple-state-checkbox.component';
import { IrisFieldChipsComponent } from './field-chips/field-chips.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IrisFieldInlineEditingComponent } from './field-inline-editing/field-inline-editing.component';
import { IrisFieldButtonGroupSelectorComponent } from '@iris/common/modules/fields/field-button-group-selector/button-group-selector.component';
import { IrisFieldTranslateComponent } from './field-translate/field-translate.component';
import { IrisFieldTranslateModule } from '@iris/common/modules/fields/field-translate/field-translate.module';
import { PortalModule } from '@angular/cdk/portal';
import { IrisInfoIconComponent } from '../ui/modules/info-icon/info-icon.component';
import { SafeHtmlPipe } from '../pipes-common/pipes';
import {
  StrakitButtonComponent,
  StrakitSelectComponent,
  StrakitTextComponent,
} from '@ngx-strakit/cdk/controls';
import {
  StrakitButtonPrefixDirective,
  StrakitControlSuffixDirective,
  SkModalContentComponent,
} from '@ngx-strakit/cdk';
import { SortItemsDirective } from '@iris/common/modules/fields/sk-select-field/directives/sort-items.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EditorModule,
    MatCheckboxModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSlideToggleModule,
    IrisCommonDirectivesModule,
    ColorSketchModule,
    ColorSwatchesModule,
    IrisCommonPipesModule,
    SkModalContentComponent,
    MatTooltipModule,
    SafeHtmlPipe,
    IrisFieldTranslateModule,
    PortalModule,
    IrisInfoIconComponent,
    IrisFieldButtonGroupSelectorComponent,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
    StrakitControlSuffixDirective,
    StrakitSelectComponent,
    SortItemsDirective,
    StrakitTextComponent,
  ],
  declarations: [
    IrisFieldEditorComponent,
    IrisFieldChipsComponent,
    IrisFieldDepartmentComponent,
    IrisFieldDepartmentModalComponent,
    IrisFieldShareSelectComponent,
    IrisFieldMultipleStateCheckboxComponent,
    IrisFieldInlineEditingComponent,
  ],
  exports: [
    IrisFieldEditorComponent,
    IrisFieldChipsComponent,
    IrisFieldDepartmentComponent,
    IrisFieldShareSelectComponent,
    IrisFieldMultipleStateCheckboxComponent,
    IrisFieldInlineEditingComponent,
    IrisFieldTranslateComponent,
  ],
})
export class IrisFieldsModule {
}
